const account = {
  delete: "Delete my account",
  deleteUser: "Delete account",
  deleteWarning:
    "Are you sure you want to delete your account? Once deleted, all your data and your subscription cannot be recovered.",
  deleteUserWarning:
    "Are you sure you want to delete this account? Once deleted, all data and the subscription cannot be recovered.",
  accountCreated:
    "Your account has been successfully created. A verification email has been sent to you (it may take up to one minute to arrive. Please check your spam folder).",
  accessMyAccount: "Access my account",
  myAccount: "My account",
  yourAccountNotActive: "Your account is not yet activated.",
};

export default account;
